module.exports = __webpack_public_path__ + "static/media/A1-17-Kal-Belzeruk-Ev-cod99.f30b15dd.png";